module.exports = __webpack_public_path__ + "img/bdlogo.a229a16a.png";